import React from 'react';
import { usePreview } from '@/contexts/PreviewContext';
import { X, Eye } from 'lucide-react';

const PreviewModeBanner: React.FC = () => {
  const { previewState, isPreviewMode, exitPreviewMode } = usePreview();

  if (!isPreviewMode || !previewState) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2 text-yellow-800">
        <Eye className="w-4 h-4" />
        <span className="text-sm font-medium">
          PREVIEW MODE - {previewState.organizationName || 'Organization'}
        </span>
        <span className="text-xs text-yellow-600">
          {previewState.previewType === 'user' && previewState.previewUserName
            ? `Viewing as: ${previewState.previewUserName} (${previewState.previewUserEmail})`
            : `Viewing as role: ${previewState.role}`
          }
        </span>
      </div>
      <button
        onClick={exitPreviewMode}
        className="flex items-center gap-1 px-3 py-1 text-sm font-medium text-yellow-800 bg-yellow-100 hover:bg-yellow-200 rounded-md transition-colors"
      >
        <X className="w-4 h-4" />
        Exit Preview
      </button>
    </div>
  );
};

export default PreviewModeBanner;

